import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';
import type { UpdateChannelRequest } from '@troia-v3/types';

/**
 * Hook to update an existing channel
 *
 * @example
 * const updateChannel = useUpdateChannel();
 * updateChannel.mutate({ id: 'channelId', data: updateData });
 */
export const useUpdateChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateChannelRequest }) =>
      channelsApi.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
      queryClient.invalidateQueries({ queryKey: ['channels', variables.id] });
    },
  });
};
